import { render, staticRenderFns } from "./ChartSetupWizard.vue?vue&type=template&id=33bd51be&scoped=true"
import script from "./ChartSetupWizard.vue?vue&type=script&lang=js"
export * from "./ChartSetupWizard.vue?vue&type=script&lang=js"
import style0 from "./ChartSetupWizard.vue?vue&type=style&index=0&id=33bd51be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bd51be",
  null
  
)

export default component.exports